import { BoundingBox, IBoundingBoxObject } from "./BoundingBox";
import { Octree } from "./Octree";
import { Ray } from "../Math/Ray";
import { vec3 } from "gl-matrix";

export class SpatialDatabase<T extends IBoundingBoxObject> {

    private objectMap: Map<T, Set<Octree<T>>>;
    public octree: Octree<T>;

    constructor(boundingRegion: BoundingBox) {
        this.objectMap = new Map<T, Set<Octree<T>>>();
        this.octree = new Octree<T>(boundingRegion, null, this.objectMap);
    }

    public handleMovementArray(objArray: T[]) {
        for (let obj of objArray) {
            this.handleMovement(obj);
        }
    }

    public handleMovement(obj: T) {
        this.remove(obj);
        this.add(obj);
    }

    public removeArray(objArray: T[]) {
        for (let obj of objArray) {
            this.remove(obj);
        }
    }

    public remove(obj: T) {
        if (this.objectMap.has(obj)) {
            var set = this.objectMap.get(obj);

            set.forEach((linkedTree) => {
                linkedTree.remove(obj);
            });

            this.objectMap.delete(obj);
        }
    }

    public add(obj: T) {
        this.octree.insert(obj, false);
    }

    public addArray(objArray: T[]) {
        this.octree.insertArray(objArray, false);
    }

    public optimize() {
        this.octree.prune();
    }

    public rayTrace(ray: Ray) {
        return this.octree.rayTrace(ray);
    }

    public getObjectsInRange(position: vec3, range: number): T[] {
        let bounds = new BoundingBox(
            vec3.fromValues(position[0] - range, position[1] - range, position[2] - range),
            vec3.fromValues(position[0] + range, position[1] + range, position[2] + range)
        );
        let objects = this.octree.getObjectsInRegion(bounds);

        return objects.filter(obj => vec3.distance(position, obj.getBoundingBox().getCenter()) <= range);
    }

    public getObjectsInRegion(bounds: BoundingBox) {
        return this.octree.getObjectsInRegion(bounds);
    }
}

